import { render, staticRenderFns } from "./ServiceNewPopup.vue?vue&type=template&id=1555472b&"
import script from "./ServiceNewPopup.vue?vue&type=script&lang=js&"
export * from "./ServiceNewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports